import { Component } from 'react';
import Popup from '../common/Popup';
import { DKLabel, DKButton, INPUT_VIEW_DIRECTION, DKCheckMark, DKInput, showToast, TOAST_TYPE, Toggle, DKRadioButton, DKTooltipWrapper, DKIcon, DKSpinner } from "deskera-ui-library";
import { COMPONENT_OPTION, COMPONENT_TYPE, IN_CONFIGURE_AMOUNT_BASED_ON, COMPONENT_FREQUENCY_TYPE_LIST, MONTHS, MONTHLY_WHEN, QUARTERS, QUARTERLY_WHEN, YEARLY_WHEN, defaultOtherComponents, INDefaultComponents, CONFIGURE_AMOUNT_BASED_ON, COMPONENT_TYPE_FORMULA, FORMULA } from './ComponentConstants';
import ComponentListService from '../../services/ComponentListService';
import UserService from '../../services/UserService';
import Utility, { deepClone } from '../../utility/Utility';
import SegmentListContainer from '../list/SegmentListContainer';
import moment from 'moment';
import { CONSTANTS, COUNTRY_CODE, DATE_FORMAT, INPUT_FIELD_MAP, INPUT_TYPE, PROFILE_STAGES_CONSTANT, TENENT_COUNTRY } from '../../constants/Constant';
import ProfileSetupService from '../../services/ProfileSetup-service';
import TenantManager from '../../managers/TenantManager';
import { getTenantCountryCode, isComponentFormulaConfiguration, isInCompliance, isIndiaCompliance, isMYCompliance, isSGCompliance, isUSCompliance, convertDateToJson } from '../../managers/common/CommonUtil';
import { withTranslation } from 'react-i18next';
import FormulaGrid from './FormulaGrid';
import ic_info_message from "../../assets/icons/ic_info_gray01.png";
class ComponentAddPopup extends Component<any, any> {
    countryCode = getTenantCountryCode()
    CONFIGURE_AMOUNT_BASED_ON = []
    componentData = {
        compliance: {
            countryCode: this.countryCode,

            esi: false,

            pf: false,

            taxexempt: false,
            deductionType: "posttaxdeduction",
            hasCPF: false,
            taxable: false,
            SDL: false,
            SHG: false,
            CPF: "AW"
        },
        countryCode: this.countryCode,
        componentConfig: {
            amountPerDay: 0,
            applicableValues: null,
            basisComponentId: "",
            componentPercent: 0,
            configureAmountBasis: "",
            deductionType: "posttaxdeduction"
        },
        defaultComponent: false,
        employees: [],
        frequency: {
            occurrence: null,
            period: "everyPayrun",
            when: ""
        },
        includeInCTC: true,
        includeInOTCalc: false,
        isActive: true,
        isForAllEmployee: true,
        isHidden: false,
        isVariable: this.props.isVariable  ? this.props.isVariable : false,
        isUnpaidIncluded: false,
        name: "",
        subType: "",
        type: "",
        isFormula:false,
        formula: '',
        formulaConfig: null
    }
    listOfEmployee = []
    employeeName = []
    components = []
    componentDetailList = []
    allComponent = []
    initialComponentTabs = [
        { id: 0, name: 'Details' },
        { id: 1, name: 'Frequency' }
    ]
    frequencyList = COMPONENT_FREQUENCY_TYPE_LIST;
    isLoading = false
    COMPLAINCE_FORM_FIELD = [];

    disableUnpaidDays = ["hra", "fixed_allowance", "basic_salary"]

    componentTypeOptions = isComponentFormulaConfiguration() ? COMPONENT_TYPE_FORMULA : COMPONENT_TYPE;
    isFormulaValid = true;
    formulaConfig = null;
    specificComponentList = []
    constructor(props) {
        super(props);
        this.getConfigureBasedAmountOptions()
        if(!Utility.isEmpty(this.props.employeeList)) {
            this.listOfEmployee = this.props.employeeList['users'];
            this.employeeName = this.listOfEmployee.map(emp => `${emp.firstName} ${emp.lastName}`)
            this.setState({ ...this.state, users: this.employeeName,isFormLoading:false })
        }
        this.getComponents();
        if(isMYCompliance()) {
            this.componentData['compliance']['componentCategory'] = 'remuneration';
            this.componentData['compliance']['eaFormFieldTaxExemptAmount'] = 'none';
            this.componentData['compliance']['eaFormField'] = 'none';            
            this.getComponentCategoryData()
        }
        if (this.props.selectedComponent) {
            this.componentData = deepClone(this.props.selectedComponent);
            
            if(this.props.selectedComponent && this.componentData.formulaConfig && this.componentData.formulaConfig.length>0) {
                this.componentData.formulaConfig=this.componentData.formulaConfig.map(config=>{
                    return {
                        ...config,
                        componentId: [config.componentId]
                    }
                })
            }
        } else {
            if(!this.componentData.formulaConfig) {
                this.componentData.formulaConfig = [
                    {
                        index:"A",
                        componentId:[],
                        percentage:"100",
                        invalidFields:[]
                    }
                ]
            }
        }
        if(this.componentData['isFormula']) {
            this.componentData.isVariable = false;
            this.componentData.isFormula = true
        }

        this.state = {
            componentData: this.componentData,
            isEdit: ((this.props.selectedComponent) ? true : false),
            users: this.employeeName,
            components: this.components,
            selectedTab: 0,
            isFormLoading: this.listOfEmployee.length === 0
        }
        
    }
    componentDidMount() {
        this.setState({
            ...this.state
        })
    }
    componentDidUpdate() {
        if(this.props.employeeList && this.props.employeeList['users'] && Utility.isEmpty(this.listOfEmployee)) {
            this.listOfEmployee = this.props.employeeList['users'];
            this.employeeName = this.listOfEmployee?.map(emp => `${emp.firstName} ${emp.lastName}`)
            this.setState({ ...this.state, users: this.employeeName,isFormLoading:false })
        }
    }
    getConfigureBasedAmountOptions(){
        switch(getTenantCountryCode()) {
            case COUNTRY_CODE.INDIA:
                this.CONFIGURE_AMOUNT_BASED_ON = IN_CONFIGURE_AMOUNT_BASED_ON;
                break;
            default:
                this.CONFIGURE_AMOUNT_BASED_ON = CONFIGURE_AMOUNT_BASED_ON;
                break;
        }

        this.CONFIGURE_AMOUNT_BASED_ON.forEach((i) => {
            if (i.id === "percentageOfSpecificComponent") {
                i.name = this.props.t("PERC_OF_SPEC_COMP");
            }
        });
    }
    getComponentTabs() {
        let tabs = Object.assign([], this.initialComponentTabs);
        switch(getTenantCountryCode()) {
            case COUNTRY_CODE.US:
                if(this.componentData.type == 'DEDUCTION'){
                    tabs.push({ id: 2, name: 'Compliance' });
                }
                break;
            case COUNTRY_CODE.INDIA:
                if (this.componentData.type == 'EARNING' && !isUSCompliance()) {
                    tabs.push({ id: 2, name: 'Compliance' });
                }
                break;
            case COUNTRY_CODE.SG:
                tabs.push({ id: 2, name: 'Compliance' });
                break;
            case COUNTRY_CODE.MY:
                if ((this.componentData.type == 'DEDUCTION' ||this.componentData.type == 'EARNING') && !isUSCompliance()) {
                    tabs.push({ id: 2, name: 'Compliance' })
                }
                break;
            default:
                break;
        }
        if(isComponentFormulaConfiguration() && this.componentData.isFormula) {
            tabs.push({ id: 3, name: FORMULA })
        }
        return tabs;
    }
    getUsers() {
        this.setState({
            ...this.state,
            isFormLoading:true
        })
        UserService.getAllUsers()
            .then(res => {
                if (res['users']) {
                    this.listOfEmployee = res['users'];
                    this.employeeName = this.listOfEmployee.map(emp => `${emp.firstName} ${emp.lastName}`)
                    if (!this.componentData.isForAllEmployee) {
                        this.setState({
                            ...this.state,
                            users: this.employeeName,
                            isFormLoading:false
                        })
                    } else {
                        this.setState({...this.state,isFormLoading:false })
                    }
                }
            }, error => {
                this.setState({...this.state,isFormLoading:false })
                console.log(error)
            })
    }
    getComponents() {
        ComponentListService.getAllComponent()
            .then(res => {
                if (res['components']) {
                    this.allComponent = res['components'];
                    if(!this.props.selectedComponent && this.componentData.formulaConfig[0] && isComponentFormulaConfiguration()) {
                        let basic = this.allComponent.find(comp=>(comp.name=="Basic" && comp.defaultComponent))
                        this.componentData.formulaConfig[0].componentId = [basic.id]
                    }
                    
                    this.filterComponent();
                    if (this.componentData.isVariable && this.componentData.componentConfig.configureAmountBasis == this.CONFIGURE_AMOUNT_BASED_ON[1].id) {
                        this.setState({ components: this.components, allComponent :this.allComponent })
                    } else {
                        this.setState({ allComponent :this.allComponent })
                    }
                }
            },
                error => {
                    console.log(error)
                })
    }
    getComponentCategoryData() {
        ComponentListService.getComponentCategory().then(res=>{
            if(res && res['form_fields']) {
                this.COMPLAINCE_FORM_FIELD = res['form_fields']
            }
        })
    }
    filterComponent() {
        if (this.componentData.type != "") {
            this.componentDetailList = this.allComponent.filter(ele => (ele.type == this.componentData.type && ele.subType !== "fixed_allowance"));
            this.components = this.componentDetailList
        } else {
            this.componentDetailList = [];
            this.components = []  
        }
        this.specificComponentList = this.allComponent.filter(ele => (ele.subType !== "fixed_allowance"));
    }
    onClose() {
        this.props.onClose();
    }
    isDefaultComponent(fieldName) {
        return ((this.componentData.defaultComponent && defaultOtherComponents.includes(fieldName)) || isMYCompliance())
    }
    isINDefaultComponent(subType) {
        return (this.componentData.defaultComponent && INDefaultComponents.includes(subType))
    }
    isIncludeForCTC(compName) {
        return ((this.componentData.defaultComponent && defaultOtherComponents.includes(compName)) || !this.componentData.defaultComponent)
    }
    isValid() {
        if (this.componentData.name.trim() == "") {
            return false;
        }
        let config = this.componentData.componentConfig;
        if(isComponentFormulaConfiguration() && this.componentData.isFormula) {
            this.componentData.isVariable = false;
            if(!this.isFormulaValid || Utility.isEmpty(this.componentData.formula)) {
                showToast("Formula is not valid.", TOAST_TYPE.FAILURE)
                this.setState({
                    selectedTab: 3
                });
                return false;
            } else if(Utility.isEmpty(this.componentData.formulaConfig)) {
                showToast("Please add all the earnings or deductions involved the calculation of the payroll component.", TOAST_TYPE.FAILURE)
                this.setState({
                    selectedTab: 3
                });
                return false;
            } else {
                this.formulaConfig = this.componentData.formulaConfig?.map(config=>{
                    delete config.invalidFields;
                    delete config.selected;
                    return {
                        ...config,
                        componentId: (config.componentId && config.componentId.length!=0) ?  config.componentId[0]:"",
                        percentage: parseFloat(config.percentage)
                    }
                })
            }
        } else {
            this.componentData.formulaConfig = null;
        }
        if (this.componentData.isVariable) {
            if (config.configureAmountBasis == "") {
                showToast("Please select Configure Amount basis on ", TOAST_TYPE.FAILURE)
                return false;
            }
        }
        if (this.componentData.type == "") {
            showToast("Please select Componnet Type ", TOAST_TYPE.FAILURE)
            return false;
        }
        if (this.componentData.type == "DEDUCTION" && this.componentData.compliance) {
            this.componentData.compliance.esi = false;
            this.componentData.compliance.pf = false;
        }
        if(isUSCompliance()) {
            if(this.componentData.compliance) {
                delete this.componentData.compliance.esi
                delete this.componentData.compliance.taxexempt
                delete this.componentData.compliance.pf
                if(this.componentData.compliance['bsiCode']) {
                    delete this.componentData.compliance['bsiCode']
                }
            }

            delete this.componentData.includeInCTC
        }
        this.componentData.countryCode= this.countryCode;
        if (!this.componentData.isForAllEmployee && this.componentData.employees.length == 0) {
            showToast("Please select Users ", TOAST_TYPE.FAILURE)
            return false;
        }
        switch (config.configureAmountBasis) {
            case "percentageOfSpecificComponent":
                if ((config.componentPercent.toString() == "" || config.componentPercent.toString().trim() == "" || config.basisComponentId == "" || config.componentPercent >100)) {
                    showToast(this.props.t("PERC_OF_SPEC_COMP_VAL_MSG_2"), TOAST_TYPE.FAILURE)
                    return false;
                }
                break;
            case "percentageOfBasicSalary":
                const threshold = this.componentData.subType === "hra" ? CONSTANTS.HRA_THRESHOLD : 100;
                if ((config.componentPercent.toString() == "" || config.componentPercent.toString().trim() == "")|| config.componentPercent > threshold) {
                    showToast("Please enter valid percentage amount", TOAST_TYPE.FAILURE)
                    return false;
                }
                break;
            case "amountPerDay":
                if (config.amountPerDay.toString() == "" || config.amountPerDay.toString().trim() == "") {
                    return false;
                }
                break;
            case "percentageOfCTC":
                if (config.componentPercent.toString() == "" || config.componentPercent.toString().trim() == ""|| config.componentPercent > CONSTANTS.BASIC_THRESHOLD) {
                    showToast("Please enter valid percentage", TOAST_TYPE.FAILURE)
                    return false;
                }
                break;

        }
        if (this.componentData.frequency.period == "") {
            return false;
        }
        switch (this.componentData.frequency.period) {
            case COMPONENT_FREQUENCY_TYPE_LIST[1].id:
            case COMPONENT_FREQUENCY_TYPE_LIST[2].id:
                if (this.componentData.frequency.when == "" || (this.componentData.frequency.occurrence == null)) {
                    return false;
                }
                break;
            case COMPONENT_FREQUENCY_TYPE_LIST[3].id:
            case COMPONENT_FREQUENCY_TYPE_LIST[4].id:
                if (this.componentData.frequency.when == "") {
                    return false
                }
                break;


        }
        return true;
    }

    getPayload(payload) {
        Object.keys(payload.componentConfig).forEach(key => {
            if (key === "componentPercent" || key === "amountPerDay") {
                payload.componentConfig[key] =  !isNaN(parseFloat(payload.componentConfig[key])) ? parseFloat(payload.componentConfig[key]) : 0;
            }
            if(isMYCompliance() || isSGCompliance()) {
                payload['includeInCTC'] = false;
            }          
        });
        if(payload?.frequency?.period === COMPONENT_FREQUENCY_TYPE_LIST[4].id && payload?.frequency?.when) {
            payload["frequency"]["when"] = convertDateToJson(payload["frequency"]["when"]);
        }

        return payload;
    }

    saveComponent() {
        if (!this.isValid()) {
            this.setState({
                componentData: this.componentData
            })
            return;
        }

        this.isLoading = true;
        this.setState({
            componentData :this.componentData
        });
        this.componentData = {
            ...this.componentData,
            formulaConfig:this.formulaConfig
        }
        const payload = this.getPayload({...this.componentData});

        if (this.state.isEdit) {
            ComponentListService.updateComponent(payload)
                .then(res => {
                    showToast(
                        this.props.t("COMP_UPDATE_SUCCESS"),
                        TOAST_TYPE.SUCCESS
                    );
                    ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.COMPONENT)
                    .then(res=>{
                        TenantManager.setProfileData(res['profileStages']);
                    })
                    this.props.onClose(true);
                },
                    error => {
                        this.isLoading = false;
                        
                        let errorMessage = 'Internal server error'
                        if(error && !Utility.isEmpty(error) && typeof(error) == 'string' && error.trim() == "invalid formula") {
                            errorMessage = 'Please enter a valid Formula'
                        }
                        showToast(
                            errorMessage,
                            TOAST_TYPE.FAILURE
                        );
                    })
        } else {
            ComponentListService.saveComponent(payload)
                .then(res => {
                    showToast(
                        this.props.t("COMP_ADD_SUCCESS"),
                        TOAST_TYPE.SUCCESS
                    );
                    this.props.onClose(true);
                },
                    error => {
                        this.isLoading = false;
                        
                        let errorMessage = 'Internal server error'
                        if(error && !Utility.isEmpty(error) && typeof(error) == 'string' && error.trim() == "invalid formula") {
                            errorMessage = 'Please enter a valid Formula'
                        }
                        showToast(
                            errorMessage,
                            TOAST_TYPE.FAILURE
                        );
                    })
        }

    }
    isApplicableToChange() {
        this.componentData.isForAllEmployee = !this.componentData.isForAllEmployee;
        this.setState({
            componentData: this.componentData,
            users: this.employeeName
        })
    }
    isIncludeCTCChange() {
        this.componentData.includeInCTC = !this.componentData.includeInCTC;
        this.updateComponentData();
    }
    isIncludeInOTCalcChange() {
        this.componentData.includeInOTCalc = !this.componentData.includeInOTCalc;
        this.updateComponentData();
    }
    isActive() {
        this.componentData.isActive = !this.componentData.isActive;
        this.updateComponentData();
    }
    getIndex(value, options) {
        if (value) {
            let ops = options.map(ele => ele.toLowerCase())
            let index = ops.indexOf(value.toLowerCase());
            return (index != -1) ? [index] : []
        } else {
            return []
        }

    }
    isUnpaidChange() {
        if(this.disableUnpaidDays.includes(this.componentData.subType)) {
            this.componentData.isUnpaidIncluded = true
        } else {
            this.componentData.isUnpaidIncluded = !this.componentData.isUnpaidIncluded;
        }
        this.updateComponentData();
    }

    getValueObject(value, options, key) {
        let item:any;
        if(typeof value === "object") {
            let index = options.findIndex(ele => ele[key] === value[key]);
            if(index != -1) {
                item = options[index];
            }
        } else if(typeof value === "string") {
            let index = options.findIndex(ele => ele.toLowerCase() === value.toLowerCase());
            if(index != -1) {
                item = options[index];
            }
        }
        return item;
    }
    getValueFormDropDownList(value, options, key) {
        let item:any;
        let ind = options.findIndex(ele => ele[key] === value);
        if(ind != -1) {
            item = options[ind];
        }
        return item
    }
    updateComponentData() {
        this.setState({
            componentdata: this.componentData
        })
    }
    onSegmentSelect = (segment, index) => {
        this.setState({
            selectedTab: (segment.id)
        });
    };
    onUserSelect(users) {
        let employees = [];
        users.forEach(userIndex => {
            employees.push(this.listOfEmployee[userIndex].userId)
        })

        this.componentData.employees = employees
    }
    getSelectedUserIndex() {
        let index = []
        this.componentData.employees?.forEach(emp => {

            this.listOfEmployee.forEach((ele, i) => {
                if (ele.userId == emp) {
                    index.push(i)
                }
            })
        })
        return index
    }
    getSelectedConfig() {
        let ind = {};
        if (!Utility.isEmpty(this.componentData.componentConfig.configureAmountBasis)) {
            let index = this.CONFIGURE_AMOUNT_BASED_ON.findIndex(x=> x.id === this.componentData.componentConfig.configureAmountBasis);
            if(index != -1) {
                ind = this.CONFIGURE_AMOUNT_BASED_ON[index]
            }
        }
        return ind;

    }
    getSelectedComponent() {
        let ind = {};
        if (this.componentData.componentConfig.basisComponentId != "") {
            let index = this.specificComponentList.findIndex(ele => ele.id === this.componentData.componentConfig.basisComponentId);
            if(index != -1) {
                ind = this.specificComponentList[index];
            }
        }
        return ind;
    }
    getFrquency() {
        let val = this.componentData.frequency.period;
        let array = COMPONENT_FREQUENCY_TYPE_LIST.find(item => item.id === val);
        return array;
    }
    getOccurrence(occurrence, months) {
        let array = [];
        if (occurrence) {
            occurrence.forEach(data => {
                months.find(function (item, i) {
                    if (item.id === data) {
                        array.push(i)
                    }
                });
            })
        }
        return array;
    }
    getWhen(whenFrom, whenArr) {
        let object = {}
        let index = whenArr.findIndex(item => item.id === whenFrom);
        if(index != -1) {
            object = whenArr[index];
        }
        return object;
    }
    getTitle() {
        switch (this.componentData.frequency.period) {
            case COMPONENT_FREQUENCY_TYPE_LIST[1].id:
                return "Monthly";
            case COMPONENT_FREQUENCY_TYPE_LIST[2].id:
                return "Quarterly";
            default:
                return ''
        }
    }
    getOptions() {
        switch (this.componentData.frequency.period) {
            case COMPONENT_FREQUENCY_TYPE_LIST[1].id:
                return MONTHS;
            case COMPONENT_FREQUENCY_TYPE_LIST[2].id:
                return QUARTERS;
            default:
                return []
        }
    }
    getWhenOptions() {

        switch (this.componentData.frequency.period) {
            case COMPONENT_FREQUENCY_TYPE_LIST[1].id:
                return MONTHLY_WHEN;
            case COMPONENT_FREQUENCY_TYPE_LIST[2].id:
                return QUARTERLY_WHEN;
            case COMPONENT_FREQUENCY_TYPE_LIST[3].id:
                return YEARLY_WHEN;
            default:
                return []
        }
    }
    isPercentageOfCTCShow(){
        return (isIndiaCompliance()&& this.componentData.componentConfig.configureAmountBasis == this.CONFIGURE_AMOUNT_BASED_ON[3].id)
    }
    includeInCTC(){
        return isIndiaCompliance() && this.componentData.type == "EARNING"
    }
    isEaringComponent() {
        return (this.componentData.type == "EARNING" && !isMYCompliance());
    }
    getIsComplianceFieldHidden(field) {
        switch (field.fieldId) {
            case "eaFormFieldTaxExemptAmount":
                return this.componentData.compliance['pcb'];
            case "componentCategory":
                return this.componentData.type == "EARNING"
            default:
                return !field.hidden
        }
    }

    getSGComplianceSection() {
        return (
            <>
                <div className="row pt-l " style={{ height: 84 }}>
                    <DKInput
                        title={this.props.t("COMPONENT_NAME")}
                        value={this.componentData.name}
                        showError={true}
                        errorMessage={this.props.t("ADD_COMP_VAL_MSG_1")}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        readOnly={true}
                        required={false}
                        canValidate={true}
                        onChange={(value) => {
                            this.componentData.name = value
                            this.updateComponentData()
                        }}
                    />
                </div>
                <div className="row">
                    <div
                        className="row pt-l align-items-center parent-height cursor-hand" style={{width:"30%"}}
                        onClick={() => {
                            if (this.componentData.compliance) {
                                this.componentData.compliance.hasCPF = !this.componentData.compliance.hasCPF;
                            } else {
                                this.componentData.compliance = { ...this.componentData.compliance, hasCPF: true, countryCode: this.countryCode }
                            }
                            this.updateComponentData()
                        }}

                    >
                        <DKCheckMark isSelected={this.componentData.compliance && this.componentData.compliance.hasCPF} color="bg-app" /><DKLabel className="ml-s" text={"CPF"} />
                    </div>
                    {this.componentData.compliance.hasCPF && (
                        <>
                        <div
                        className={`pt-l pr-l align-items-center parent-height cursor-hand' }`}
                        onClick={() => {
                            if (this.componentData.compliance) {

                                this.componentData.compliance = { ...this.componentData.compliance, CPF: 'AW' }
                            }
                            this.updateComponentData()
                        }}

                    >
                        <DKRadioButton
                            title="AW"
                            className="mb-xs cursor-hand"
                            color="bg-app"
                            isSelected={this.componentData.compliance && this.componentData.compliance.CPF === "AW"}
                            onClick={(e) => {
                                if (this.componentData.compliance) {
                                    this.componentData.compliance = { ...this.componentData.compliance, CPF: 'AW' }

                                }
                            }
                            }

                        />
                    </div>
                    <div
                        className={`pt-l align-items-center parent-height cursor-hand' }`}
                        onClick={() => {
                            if (this.componentData.compliance) {

                                this.componentData.compliance = { ...this.componentData.compliance, CPF: 'OW' }
                            }
                            this.updateComponentData()
                        }}

                    >
                        <DKRadioButton
                            title="OW"
                            className="mb-xs cursor-hand"
                            color="bg-app"
                            isSelected={this.componentData.compliance && this.componentData.compliance.CPF !== "AW"}
                            onClick={(e) => {
                                if (this.componentData.compliance) {
                                    this.componentData.compliance = { ...this.componentData.compliance, CPF: 'OW' }

                                }
                            }
                            }

                        />
                    </div>
                    </>
                    )}
                </div>
                <div
                    className="row pt-l align-items-center parent-height cursor-hand"
                    onClick={() => {
                        if (this.componentData.compliance) {
                            this.componentData.compliance.taxable = !this.componentData.compliance.taxable;
                        } else {
                            this.componentData.compliance = { ...this.componentData.compliance, taxable: true }
                        }
                        this.updateComponentData()
                    }}

                >
                    <DKCheckMark isSelected={this.componentData.compliance && this.componentData.compliance.taxable} color="bg-app" /><DKLabel className="ml-s" text={"Tax"} />
                </div>
                <div
                    className="row pt-l align-items-center parent-height cursor-hand"
                    onClick={() => {
                        if (this.componentData.compliance) {
                            this.componentData.compliance.SDL = !this.componentData.compliance.SDL;
                        } else {
                            this.componentData.compliance = { ...this.componentData.compliance, SDL: true, countryCode: this.countryCode }
                        }
                        this.updateComponentData()
                    }}

                >
                    <DKCheckMark isSelected={this.componentData.compliance && this.componentData.compliance.SDL} color="bg-app" /><DKLabel className="ml-s" text={"SDL"} />
                </div>
                <div
                    className="row pt-l align-items-center parent-height cursor-hand"
                    onClick={() => {
                        if (this.componentData.compliance) {
                            this.componentData.compliance.SHG = !this.componentData.compliance.SHG;
                        } else {
                            this.componentData.compliance = { ...this.componentData.compliance, SHG: true, countryCode: this.countryCode }
                        }
                        this.updateComponentData()
                    }}

                >
                    <DKCheckMark isSelected={this.componentData.compliance && this.componentData.compliance.SHG} color="bg-app" /><DKLabel className="ml-s" text={"SHG"} />
                </div>
            </>

        )
    }

    getMYComplianceSection() {
        return (
            <>
                <div className="row pt-l " style={{ height: 84 }}>
                    <DKInput
                        title={this.props.t("COMPONENT_NAME")}
                        value={this.componentData.name}
                        showError={true}
                        errorMessage={this.props.t("ADD_COMP_VAL_MSG_1")}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        readOnly={true}
                        required={false}
                        canValidate={true}
                        onChange={(value) => {
                            // this.componentData.name = value
                            // this.updateComponentData()
                        }}
                    />
                </div>
                {
                    this.COMPLAINCE_FORM_FIELD.map(field=>{
                        return (
                        <>
                                {(field.fieldType != 'checkbox' && (this.getIsComplianceFieldHidden(field))) &&<div className="row pt-l " style={{ height: 84 }}>


                                    <DKInput
                                        title={field.fieldLabel}
                                        value={!Utility.isEmpty(this.componentData['compliance'][field['fieldId']]) ? this.getValueFormDropDownList(this.componentData['compliance'][field['fieldId']], field['options'], 'id') : ""}
                                        formatter={(obj) => {
                                            /** How to render selected value from strig of Array */
                                            return obj.name;
                                        }}
                                        className="mb-l"
                                        type={INPUT_FIELD_MAP[field.fieldType] === INPUT_TYPE.SELECT ? INPUT_TYPE.DROPDOWN : field.fieldType}
                                        showError={false}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                        readOnly={false}
                                        required={true}
                                        canValidate={true}
                                        options={field['options']}
                                        onChange={(value) => {
                                            if (!Utility.isEmpty(value)) {
                                                this.componentData['compliance'][field['fieldId']] = value.id
                                            } else {
                                                this.componentData['compliance'][field['fieldId']] = ''
                                            }
                                            // this.filterComponent()
                                            this.updateComponentData()

                                        }}
                                        dropdownConfig={{
                                            className: "",
                                            style: {},
                                            allowSearch: field['options'] && field['options'].length > 6 ? true : false,
                                            searchableKey: "name",
                                            data: field['options'],
                                            renderer: (index, obj) => {
                                                /*How to render dropdwon options from string of array*/
                                                return <DKLabel className="" text={obj.name} />;
                                            },
                                            onSelect: (index, value) => { },
                                        }}
                                    />


                                </div>}
                                
                                {
                                    field.fieldType == 'checkbox' && (
                                        <div
                                            className="row p-v-m align-items-center  cursor-hand" 
                                            onClick={() => {
                                                if (this.componentData.compliance) {
                                                    this.componentData.compliance[field.fieldId] = !this.componentData.compliance[field.fieldId];
                                                    
                                                } 
                                                this.updateComponentData()
                                            }}

                                        >
                                            <DKCheckMark isSelected={this.componentData.compliance && this.componentData.compliance[field.fieldId]} color="bg-app" /><DKLabel className="ml-s" text={field.fieldLabel} />
                                        </div>
                                    )
                                }
                                
                                </>
                        )
                    })
                }
                
            </>
        )
    }
    getTypeValue() {
        if (this.componentData.isVariable) {
            return "Variable";
        } else if (this.componentData.isFormula) {
            return FORMULA;
        } else {
            return "Fixed";
        }
    }
    onValueFormulaUpdate(data) {
        this.isFormulaValid = data.isFormulaValid;
        this.componentData.formula = data.formula;
        this.componentData.formulaConfig = deepClone(data.formulaConfig);
    }
    getFormulaComponent() {
        return (
            <FormulaGrid 
            componentList={this.state.allComponent} 
            componentData={this.componentData} 
            onValueFormulaUpdate={(data)=>{
                this.onValueFormulaUpdate(data)
            }}
            />
        )
    }
    render() {
        return (
            <>
                <Popup>
                    <div className="custom-scroll pr-xs" style={{ height: '80vh', overflowY: "auto" }}>
                        <div className="d-flex justify-content-between">
                            <div  className="d-flex align-items-center">
                            <DKLabel text={this.state.isEdit ? this.props.t("EDIT_COMPONENT") : this.props.t("ADD_COMPONENT")} className="fs-m fw-m align-self-center" />
                            {
                                this.state.isFormLoading && <DKSpinner className="ml-s"/>
                            }
                            </div>
                            <div className="d-flex m-v-s ">
                                <DKButton
                                    title="Cancel"
                                    className="g-gray1 border-m"
                                    onClick={(event) => {
                                        this.onClose();
                                    }}
                                />
                                <DKButton
                                    title="Save"
                                    className={`border-m ml-r border-n text-white  ${this.isLoading ? "bg-gray" : "bg-app"} `} disabled={this.isLoading}

                                    onClick={() => {
                                        if(this.componentData.isFormula) {
                                            setTimeout(()=>{
                                                this.saveComponent()
                                            },100)
                                        } else {
                                            this.saveComponent()
                                        }
                                    }}
                                />

                            </div>
                        </div>
                        <div className="">
                            <SegmentListContainer
                                data={this.getComponentTabs()}
                                selectedId={this.state.selectedTab}
                                onChange={(segment, index) => { this.onSegmentSelect(segment, index) }}
                                // className="d-flex justify-content-end"
                                onClickNew={() => { console.log() }}
                                maxWidth="100%"
                                isAddEnabled={false}
                                customTab={true}
                            />
                        </div>
                        {(this.state.selectedTab == 0) && <div className="parent-width">

                            <div style={{ height: 84 }}>
                                <DKInput
                                    title={this.props.t("COMPONENT_NAME")}
                                    value={this.componentData.name}
                                    showError={true}
                                    errorMessage={this.props.t("ADD_COMP_VAL_MSG_1")}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    readOnly={this.componentData.defaultComponent}
                                    required={true}
                                    canValidate={true}
                                    onChange={(value) => {
                                        this.componentData.name = value
                                        this.updateComponentData()
                                    }}
                                />
                            </div>
                            <DKInput
                                title={this.props.t("COMPONENT_TYPE")}
                                value={ !Utility.isEmpty(this.componentData.type) ? this.getValueObject(this.componentData.type, COMPONENT_OPTION, "") : ""}
                                formatter={(obj) => {
                                /** How to render selected value from strig of Array */
                                  return obj;
                                }}
                                className="mb-l"
                                type={INPUT_TYPE.DROPDOWN}
                                showError={false}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={this.componentData.defaultComponent}
                                required={true}
                                canValidate={true}
                                options={COMPONENT_OPTION}
                                onChange={(value) => {
                                    if (!Utility.isEmpty(value)) {
                                        this.componentData.type = value.toUpperCase()
                                    } else {
                                        this.componentData.type = ""
                                    }
                                    this.filterComponent()
                                    this.updateComponentData()

                                }}
                                dropdownConfig={{
                                  className: "",
                                  style: {},
                                  allowSearch: COMPONENT_OPTION && COMPONENT_OPTION.length > 6 ? true : false,
                                  searchableKey: undefined,
                                  data: COMPONENT_OPTION,
                                  renderer: (index, obj) => {
                                    /*How to render dropdwon options from string of array*/
                                    return <DKLabel className="" text={obj} />;
                                  },
                                  onSelect: (index, value) => {},
                                }}
                            />
                            <DKInput
                                title="Type"
                                value={this.getTypeValue()}
                                formatter={(obj) => {
                                /** How to render selected value from strig of Array */
                                  return obj;
                                }}
                                className="mb-l"
                                type={INPUT_TYPE.DROPDOWN}
                                showError={false}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={this.componentData.defaultComponent}
                                required={true}
                                canValidate={true}
                                options={this.componentTypeOptions}
                                onChange={(value) => {
                                    if (!Utility.isEmpty(value)) {
                                        if(value === FORMULA) { 
                                            this.componentData.isVariable = false;
                                            this.componentData.isFormula = true;
                                        } else {
                                            this.componentData.isVariable = value === "Variable" ? true: false
                                            this.componentData.isFormula = false;
                                        }
                                    } else {
                                        this.componentData.isVariable = false;
                                        this.componentData.isFormula = false;
                                    }
                                    this.updateComponentData()
                                }}
                                dropdownConfig={{
                                  className: "",
                                  style: {},
                                  allowSearch: this.componentTypeOptions && this.componentTypeOptions.length > 6 ? true : false,
                                  searchableKey: undefined,
                                  data: this.componentTypeOptions,
                                  renderer: (index, obj) => {
                                    /*How to render dropdwon options from string of array*/
                                    return <DKLabel className="" text={obj} />;
                                  },
                                  onSelect: (index, value) => {},
                                }}
                            />
                            {(this.componentData.isVariable) && (
                                <>
                                    <DKInput
                                        title="Configure Amount Based On"
                                        value={this.getSelectedConfig()}
                                        formatter={(obj) => {
                                        /** How to render selected value from strig of Array */
                                          return obj.name;
                                        }}
                                        className="mb-l "
                                        type={INPUT_TYPE.DROPDOWN}
                                        showError={false}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                        readOnly={this.componentData.defaultComponent}
                                        required={true}
                                        canValidate={true}
                                        options={this.CONFIGURE_AMOUNT_BASED_ON.map(config => { return config.name })}
                                        onChange={(value) => {
                                            if (!Utility.isEmpty(value)) {
                                                this.componentData.componentConfig.configureAmountBasis = value.id;
                                            } else {
                                                this.componentData.componentConfig.configureAmountBasis = "";
                                            }
                                            this.updateComponentData()
                                        }}
                                        dropdownConfig={{
                                            className: "",
                                            style: {},
                                            allowSearch: this.CONFIGURE_AMOUNT_BASED_ON && this.CONFIGURE_AMOUNT_BASED_ON.length > 6 ? true : false,
                                            searchableKey: undefined,
                                            data: this.CONFIGURE_AMOUNT_BASED_ON,
                                            renderer: (index, obj) => {
                                              /*How to render dropdwon options from string of array*/
                                              return <DKLabel className="" text={obj.name} />;
                                            },
                                            onSelect: (index, value) => {},
                                        }}
                                    />

                                    {this.componentData.componentConfig.configureAmountBasis == this.CONFIGURE_AMOUNT_BASED_ON[0].id &&
                                        <DKInput
                                            title="Percentage of basic "
                                            value={this.componentData.componentConfig.componentPercent}
                                            className="mb-l"
                                            type={INPUT_TYPE.NUMBER}
                                            showError={false}
                                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                            readOnly={false}
                                            required={true}
                                            canValidate={true}
                                            onChange={(value) => {
                                                this.componentData.componentConfig.componentPercent = value;
                                                const threshold = this.componentData.subType === "hra" ? CONSTANTS.HRA_THRESHOLD : 100;
                                                if (value > threshold) {
                                                    showToast(`Percentage of Basic should not greater than ${threshold}`, TOAST_TYPE.FAILURE);
                                                }
                                                this.updateComponentData()
                                            }}
                                        />
                                    }

                                    {this.componentData.componentConfig.configureAmountBasis == this.CONFIGURE_AMOUNT_BASED_ON[1].id &&
                                        <>
                                            <DKInput
                                                title={this.props.t("COMPONENT")}
                                                value={this.getSelectedComponent()}
                                                formatter={(obj) => {
                                                /** How to render selected value from strig of Array */
                                                  return obj.name;
                                                }}
                                                className="mb-l"
                                                type={INPUT_TYPE.DROPDOWN}
                                                showError={false}
                                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                                readOnly={this.componentData.defaultComponent}
                                                required={true}
                                                canValidate={true}
                                                options={this.specificComponentList}
                                                onChange={(value) => {
                                                    if (!Utility.isEmpty(value)) {
                                                        this.componentData.componentConfig.basisComponentId = value.id;
                                                        // this.componentData.componentConfig.configureAmountBasis = IN_CONFIGURE_AMOUNT_BASED_ON[value].id;
                                                    } else {
                                                        this.componentData.componentConfig.basisComponentId = "";
                                                    }
                                                    this.updateComponentData()
                                                }}
                                                dropdownConfig={{
                                                    className: "",
                                                    style: {},
                                                    allowSearch: this.specificComponentList && this.specificComponentList.length > 6 ? true : false,
                                                    searchableKey: "name",
                                                    data: this.specificComponentList,
                                                    renderer: (index, obj) => {
                                                      /*How to render dropdwon options from string of array*/
                                                      return <DKLabel className="" text={obj.name} />;
                                                    },
                                                    onSelect: (index, value) => {},
                                                }}
                                            />

                                            <DKInput
                                                title={this.props.t("PERC_OF_SPEC_COMP")}
                                                value={this.componentData.componentConfig.componentPercent}
                                                className="mb-l"
                                                type={INPUT_TYPE.NUMBER}
                                                showError={false}
                                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                                readOnly={this.componentData.defaultComponent}
                                                required={true}
                                                canValidate={true}
                                                onChange={(value) => {
                                                    this.componentData.componentConfig.componentPercent = value;

                                                    if (value > 100) {
                                                        showToast(this.props.t("PERC_OF_SPEC_COMP_VAL_MSG_1"), TOAST_TYPE.FAILURE)
                                                    }
                                                    this.updateComponentData()
                                                }}
                                            />
                                        </>
                                    }

                                    {this.componentData.componentConfig.configureAmountBasis == this.CONFIGURE_AMOUNT_BASED_ON[2].id &&
                                        <DKInput
                                            title="Amount"
                                            value={this.componentData.componentConfig.amountPerDay}
                                            className="mb-l"
                                            type={INPUT_TYPE.NUMBER}
                                            showError={false}
                                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                            readOnly={this.componentData.defaultComponent}
                                            required={true}
                                            canValidate={true}
                                            onChange={(value) => {
                                                this.componentData.componentConfig.amountPerDay = value;

                                                this.updateComponentData()
                                            }}
                                        />
                                    }
                                    {this.isPercentageOfCTCShow() &&
                                        <DKInput
                                            title="Percentage of CTC"
                                            value={this.componentData.componentConfig.componentPercent}
                                            className="mb-l"
                                            type={INPUT_TYPE.NUMBER}
                                            showError={false}
                                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                            readOnly={false}
                                            required={true}
                                            canValidate={true}
                                            onChange={(value) => {
                                                this.componentData.componentConfig.componentPercent = value;
                                                if (value > CONSTANTS.BASIC_THRESHOLD) {
                                                    showToast(`Percentage of CTC should not greater than ${CONSTANTS.BASIC_THRESHOLD}`, TOAST_TYPE.FAILURE);
                                                }
                                                this.updateComponentData()
                                            }}
                                        />
                                    }
                                </>
                            )}
                            {!this.componentData.defaultComponent && <>
                            <DKLabel className="mb-s pt-m" text="Applicable to*" />
                            <div className="d-flex align-items-center  mb-l">
                                <Toggle className="border-n" isOn={(this.state.componentData) ? this.state.componentData.isForAllEmployee : true} onChange={() => this.isApplicableToChange()} /> <DKLabel className="ml-s" text={"All Users"} />
                            </div>
                            </>
                            }
                            {!this.componentData.isForAllEmployee && <DKInput
                                title="Users"
                                value={this.getSelectedUserIndex()}
                                className="mb-l"
                                type={INPUT_TYPE.MULTI_SELECT}
                                showError={false}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={false}
                                required={true}
                                canValidate={true}
                                options={this.state.users}
                                onChange={(value) => {
                                    this.onUserSelect(value)
                                }}
                            />}
                            {this.isDefaultComponent(this.componentData.name) && <div className="d-flex align-items-center  mb-l pt-m">
                                <Toggle className="border-n" isOn={this.componentData.isActive} onChange={() => this.isActive()} /> <DKLabel className="ml-s" text={"Active"} />
                            </div>}


                            {this.includeInCTC() && <div className={`d-flex align-items-center  mb-l pt-m ${(!this.isIncludeForCTC(this.componentData.name))? 'pointer-events-none': ''} `}>
                                {/* <Toggle className="border-n" isOn={this.componentData.includeInCTC} onChange={() => this.isIncludeCTCChange()} /> <DKLabel className="ml-s" text={"Include in CTC*"} /> */}
                                <div
                                    className="row pt-s align-items-center parent-height cursor-hand mb-l"
                                    onClick={() => {
                                        this.isIncludeCTCChange()
                                    }}

                                >
                                    <DKCheckMark isSelected={this.componentData.includeInCTC} color="bg-app" /><DKLabel className="ml-s" text={"Include in CTC*"} />
                                </div>
                            </div>}
                            {
                                !isMYCompliance()&&(<>
                                    <DKLabel
                                    className="mb-s pt-m"
                                    text="Applicable to Unpaid days"
                                    />
                                    <div className="d-flex align-items-center  mb-l">
                                    <Toggle
                                        className={`border-n ${this.disableUnpaidDays.includes(this.componentData.subType) ? "cursor-auto": ""}`}
                                        isOn={
                                        this.state.componentData
                                            ? this.state.componentData.isUnpaidIncluded
                                            : false
                                        }
                                        onChange={() => this.isUnpaidChange()}
                                    />
                                    </div>
                                </>)
                            }
                            {this.isEaringComponent() && <div
                                className="row align-items-center parent-height cursor-hand mb-l"
                                onClick={() => {
                                    this.isIncludeInOTCalcChange()
                                }}
                            >
                                <DKCheckMark isSelected={this.componentData.includeInOTCalc} color="bg-app" />
                                <DKLabel className="ml-s" text={"Include in Overtime calculations"} />
                                <DKTooltipWrapper
                                    content={`This will work for employees not part<br> of any Shift/Overtime policy.`}
                                    tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
                                >
                                    <DKIcon
                                        src={ic_info_message}
                                        className="ml-s ic-s ml-r mt-xs cursor-hand "
                                        style={{ opacity: 0.4 }}
                                    />
                                </DKTooltipWrapper>
                            </div>}
                        </div>}

                        {/* Frequency */}
                        {(this.state.selectedTab == 1) && <div className="parent-width">

                            <DKInput
                                title="Frequency"
                                value={this.getFrquency()}
                                formatter={(obj) => {
                                /** How to render selected value from strig of Array */
                                  return obj.name;
                                }}
                                className="mb-l"
                                type={INPUT_TYPE.DROPDOWN}
                                showError={false}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={this.isINDefaultComponent(this.componentData.subType)}
                                required={true}
                                canValidate={true}
                                options={this.frequencyList}
                                onChange={(value) => {
                                    if (!Utility.isEmpty(value)) {
                                        this.componentData.frequency.period = value.id;
                                    } else {
                                        this.componentData.frequency.period = "";
                                    }
                                    this.componentData.frequency.occurrence = null;
                                    this.componentData.frequency.when = "";

                                    if (value.id === COMPONENT_FREQUENCY_TYPE_LIST[4].id) {
                                        if (this.props.selectedComponent?.frequency.when) {
                                            const customDate = moment(this.props.selectedComponent.frequency.when);
                                            if (customDate.isValid()) {
                                                this.componentData.frequency.when = customDate.format(DATE_FORMAT.YYYYMMDD);
                                            }
                                        } else {
                                            this.componentData.frequency.when = moment().format(DATE_FORMAT.YYYYMMDD);
                                        }
                                    }
                                    this.updateComponentData()
                                }}
                                dropdownConfig={{
                                    className: "",
                                    style: {},
                                    allowSearch: this.frequencyList && this.frequencyList.length > 6 ? true : false,
                                    searchableKey: "name",
                                    data: this.frequencyList,
                                    renderer: (index, obj) => {
                                      /*How to render dropdwon options from string of array*/
                                      return <DKLabel className="" text={obj.name} />;
                                    },
                                    onSelect: (index, value) => {},
                                }}
                            />
                            {((this.componentData.frequency.period == COMPONENT_FREQUENCY_TYPE_LIST[1].id) ||
                                this.componentData.frequency.period == COMPONENT_FREQUENCY_TYPE_LIST[2].id) && (
                                    <DKInput
                                        title={this.getTitle()}
                                        value={this.getOccurrence(this.componentData.frequency.occurrence, this.getOptions())}
                                        className="mb-l"
                                        type={INPUT_TYPE.MULTI_SELECT}
                                        showError={false}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                        readOnly={false}
                                        required={true}
                                        canValidate={true}
                                        options={this.getOptions().map(m => m.name)}
                                        onChange={(value) => {

                                            if (value.length != 0) {
                                                let monthsArr = [];
                                                let options = this.getOptions();
                                                value.forEach(val => {
                                                    monthsArr.push(options[val].id)
                                                })
                                                this.componentData.frequency.occurrence = monthsArr;
                                            } else {
                                                this.componentData.frequency.occurrence = null;
                                            }
                                            this.updateComponentData()
                                        }}
                                    />
                                )}
                            {((this.componentData.frequency.period == COMPONENT_FREQUENCY_TYPE_LIST[1].id) ||
                                (this.componentData.frequency.period == COMPONENT_FREQUENCY_TYPE_LIST[2].id) ||
                                (this.componentData.frequency.period == COMPONENT_FREQUENCY_TYPE_LIST[3].id)) && (
                                    <DKInput
                                        title="When"
                                        value={this.getWhen(this.componentData.frequency.when, this.getWhenOptions())}
                                        formatter={(obj) => {
                                        /** How to render selected value from strig of Array */
                                          return obj.name;
                                        }}
                                        className="mb-l"
                                        type={INPUT_TYPE.DROPDOWN}
                                        showError={false}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                        readOnly={false}
                                        required={true}
                                        canValidate={true}
                                        options={this.getWhenOptions()}
                                        onChange={(value) => {

                                            if (!Utility.isEmpty(value)) {
                                                this.componentData.frequency.when = value.id;
                                            } else {
                                                this.componentData.frequency.when = "";
                                            }
                                            this.updateComponentData()
                                        }}
                                        dropdownConfig={{
                                            className: "",
                                            style: {},
                                            allowSearch: this.getWhenOptions() && this.getWhenOptions().length > 6 ? true : false,
                                            searchableKey: "name",
                                            data: this.getWhenOptions(),
                                            renderer: (index, obj) => {
                                              /*How to render dropdwon options from string of array*/
                                              return <DKLabel className="" text={obj.name} />;
                                            },
                                            onSelect: (index, value) => {},
                                        }}
                                    />
                                )}
                            {(this.componentData.frequency.period == COMPONENT_FREQUENCY_TYPE_LIST[4].id) &&
                                <DKInput
                                    title="Custom Date"
                                    value={this.componentData.frequency.when ? new Date(this.componentData.frequency.when) : new Date()}
                                    className="mb-l"
                                    type={INPUT_TYPE.DATE}
                                    showError={false}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    readOnly={false}
                                    required={true}
                                    canValidate={true}
                                    onChange={(value) => {
                                        this.componentData.frequency.when = moment(value).format();
                                    }}
                                />
                            }
                        </div>}
                        {/* Component */}
                        {(this.state.selectedTab == 2) && <div className="parent-width">
                            <>
                            {isIndiaCompliance() &&<>
                            <div
                                className="row pt-l align-items-center parent-height cursor-hand"
                                onClick={() => {
                                    if(this.componentData.compliance) {
                                        this.componentData.compliance.pf = !this.componentData.compliance.pf;
                                    } else {
                                        this.componentData.compliance = { ...this.componentData.compliance, pf:true,esi:false,taxexempt:false,countryCode:this.countryCode}
                                    }
                                    this.updateComponentData()
                                }}

                            >
                                <DKCheckMark isSelected={this.componentData.compliance && this.componentData.compliance.pf} color="bg-app" /><DKLabel className="ml-s" text={"Applicable to EPF"} />
                            </div>
                            <div
                                className="row pt-l align-items-center parent-height cursor-hand"
                                onClick={() => {
                                    if(this.componentData.compliance) {
                                        this.componentData.compliance.esi = !this.componentData.compliance.esi;
                                    } else {
                                        this.componentData.compliance = {...this.componentData.compliance,pf:false,esi:true,taxexempt:false,countryCode:this.countryCode}
                                    }

                                    this.updateComponentData()
                                }}

                            >
                                <DKCheckMark isSelected={this.componentData.compliance && this.componentData.compliance.esi} color="bg-app" /><DKLabel className="ml-s" text={"Applicable to ESI"} />
                            </div>
                            <div
                                className="row pt-l align-items-center parent-height cursor-hand"
                                onClick={() => {
                                    if(this.componentData.compliance) {
                                        this.componentData.compliance.taxexempt = !this.componentData.compliance.taxexempt;
                                    } else {
                                        this.componentData.compliance = {...this.componentData.compliance,pf:false,esi:false,taxexempt:true,countryCode:this.countryCode}
                                    }

                                    this.updateComponentData()
                                }}
                            >
                                <DKCheckMark isSelected={this.componentData.compliance && this.componentData.compliance.taxexempt} color="bg-app" /><DKLabel className="ml-s" text={"Tax Exempt"} />
                            </div>
                            </>}
                                {isUSCompliance() &&
                                    <>
                                    <div className="row pt-l " style={{ height: 84 }}>
                                        <DKInput
                                            title={this.props.t("COMPONENT_NAME")}
                                            value={this.componentData.name}
                                            showError={true}
                                            errorMessage={this.props.t("ADD_COMP_VAL_MSG_1")}
                                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                            readOnly={true}
                                            required={false}
                                            canValidate={true}
                                            onChange={(value) => {
                                                this.componentData.name = value
                                                this.updateComponentData()
                                            }}
                                        />
                                    </div>
                                    <div
                                        className={`row pt-l align-items-center parent-height  ${this.componentData.defaultComponent ? 'pointer-events-none':'cursor-hand' }`}
                                        onClick={() => {
                                            if (this.componentData.compliance) {

                                                this.componentData.compliance = {...this.componentData.compliance, deductionType: 'pretaxdeduction'}
                                            }
                                            this.updateComponentData()
                                        }}

                                    >
                                    <DKRadioButton
                                      title="Pre tax deduction"
                                      className="mb-xs cursor-hand"
                                      color="bg-app"
                                      isSelected={this.componentData.compliance && this.componentData.compliance.deductionType != "posttaxdeduction"}
                                      onClick={(e) =>
                                            {
                                                if (this.componentData.compliance) {
                                                    this.componentData.compliance = {...this.componentData.compliance, deductionType: 'pretaxdeduction'}

                                                }
                                            }
                                        }
                                      disabled={this.componentData.defaultComponent}
                                    />
                                    </div>

                                    <div
                                        className={`row pt-l align-items-center parent-height  ${this.componentData.defaultComponent ? 'pointer-events-none':'cursor-hand' }`}
                                        onClick={() => {
                                            if (this.componentData.compliance) {
                                                this.componentData.compliance = {...this.componentData.compliance, deductionType: 'posttaxdeduction'}
                                            }
                                            this.updateComponentData()
                                        }}

                                    >
                                    <DKRadioButton
                                      title="Post tax deduction"
                                      className="mb-xs cursor-hand"
                                      color="bg-app"
                                      isSelected={this.componentData.compliance && this.componentData.compliance.deductionType === "posttaxdeduction"}
                                      onClick={(e) =>
                                            {
                                                if (this.componentData.compliance) {
                                                    this.componentData.compliance = {...this.componentData.compliance, deductionType: 'posttaxdeduction'}
                                                }
                                            }
                                        }
                                      disabled={this.componentData.defaultComponent}
                                    />
                                    </div>
                                    </>
                                }
                                {getTenantCountryCode() === COUNTRY_CODE.SG && (
                                    <>
                                    {this.getSGComplianceSection()}
                                    </>
                                )}
                                {isMYCompliance() && (
                                    <>
                                    {this.getMYComplianceSection()}
                                    </>
                                )}
                            </>
                        </div>}

                        {/* Formula Tab */}
                        {(this.state.selectedTab == 3) && <div className="parent-width">
                            <>
                            <DKLabel className="bg-deskera-secondary p-m border-radius-m border-m" text="Please add all the earnings or deductions involved the calculation of the payroll component"/>
                            {this.getFormulaComponent()}
                            
                            </>
                        </div>}
                    </div>
                </Popup>
            </>
        )
    }
}
export default withTranslation()(ComponentAddPopup);
